import React from 'react';
import { MDBRow, MDBCol } from "mdbreact";
import Skeleton from 'react-loading-skeleton';
import award1 from '../../assets/images/award1.png';
import award2 from '../../assets/images/award2.png';
import award3 from '../../assets/images/award3.png';

const awardImages = { 1: award1, 2: award2, 3: award3 };

const StatisticCard = ({ name, value, isRTL, loading, img = null, awardPlace = 0 }) => {
  return (
    <MDBCol xl="4" lg="4" md="6" sm="12" style={{ marginBottom: '1.5rem' }}>
      <div className="theCard">
        <p className="topCard" style={{ textAlign: isRTL ? 'right' : 'left' }}>{name}</p>
        <MDBRow style={{ flexDirection: isRTL ? 'row' : 'row-reverse' }}>
          <MDBCol md="6" sm="6">
            {awardPlace != 0 &&
              <img alt="" style={{ width: '65px', height: '65px', position: "absolute", top: "-5px", right: "-130px" }} src={awardImages[awardPlace]}></img>
            }
            {img ?
              <div className="imgWrapper" style={{ marginLeft: isRTL ? '0px' : '3rem', marginRight: '0px' }}>
                <img alt="" style={{ width: '100%' }} src={img}></img>
              </div>

              :
              <div className="iconWrapper" style={{ marginLeft: isRTL ? '0px' : '3rem', marginRight: '0px' }}>
                <img alt="" style={{ width: '100%', marginTop: '20px' }} src={require('../../assets/images/Bar Chart1.png')}></img>
              </div>
            }
          </MDBCol>
          <MDBCol md="6" sm="6">
            <p className="count" style={{ fontSize: '19px', textAlign: isRTL ? 'right' : 'left', direction: 'rtl' }}>{loading ? <Skeleton height={20} /> : value}</p>
          </MDBCol>
        </MDBRow>
      </div>
    </MDBCol>
  );
};

export default StatisticCard;
